"use strict";
exports.__esModule = true;
// 定義されていない可能性（主に開発環境で）があるので存在をチェックする
var isLogFunctionDefined = function () {
    return typeof logAmplitudeEventWithBaseProperties !== "undefined";
};
exports.logEvent = function (eventName, eventProperties) {
    if (eventProperties === void 0) { eventProperties = {}; }
    if (!isLogFunctionDefined()) {
        return;
    }
    logAmplitudeEventWithBaseProperties(eventName, eventProperties);
};
